import { render, staticRenderFns } from "./first-tips-toast.vue?vue&type=template&id=4aa89b8c&scoped=true&"
import script from "./first-tips-toast.vue?vue&type=script&lang=js&"
export * from "./first-tips-toast.vue?vue&type=script&lang=js&"
import style0 from "./first-tips-toast.vue?vue&type=style&index=0&id=4aa89b8c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4aa89b8c",
  null
  
)

export default component.exports